// apps/codeframe/src/motion/apply.ts
import { resolveCfNode } from '../store/slot-schema';
import type { AppliedStyle } from './sample';

const PROPS = ['transform', 'opacity', 'color', 'backgroundColor', 'filter', 'willChange'] as const;

/** Apply sampled styles to nodes by cf-id under `root`.
 *  Returns a reset() that clears every inline prop we touched. */
export function applyToRoot(root: HTMLElement, styles: Map<string, AppliedStyle>): () => void {
  const touched: HTMLElement[] = [];
  for (const [cfId, s] of styles) {
    const el = resolveCfNode(root, cfId) as HTMLElement | null;
    if (!el) continue;
    touched.push(el);
    el.style.willChange = 'transform';
    if (s.transform !== undefined) el.style.transform = s.transform;
    if (s.opacity !== undefined) el.style.opacity = String(s.opacity);
    if (s.color !== undefined) el.style.color = s.color;
    if (s.backgroundColor !== undefined) el.style.backgroundColor = s.backgroundColor;
    if (s.filter !== undefined) el.style.filter = s.filter;
  }
  return () => {
    for (const el of touched) for (const p of PROPS) el.style.removeProperty(p.replace(/[A-Z]/g, (m) => '-' + m.toLowerCase()));
  };
}
